var _effectorFileName = "/src/page-content/speaking-clubs/components/speaking-club-host/speaking-club-host.tsx";
import { useState } from 'react';
import { TeacherCard } from '@/page-content/teachers/components/teachers/teacher-card';
import { ReviewCard } from '@/widgets/layouts/main/reviews/review-card';
import { Article } from '@/shared/components/article';
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from '@/shared/components/ui/carousel';
import { Dialog, DialogContent } from '@/shared/components/ui/dialog';
import { Host, SPEAKING_CLUB_HOSTS } from './constants';
export const SpeakingClubHost = () => {
  const [open, setOpen] = useState(false);
  const [reviewText, setReviewText] = useState('');
  const onOpenFullReviewClick = (text: string) => {
    setReviewText(text);
    setOpen(true);
  };
  return <Article>
      <h2 className="mb-4 header-h2 sm:mb-8">Ведущие разговорного клуба</h2>

      {SPEAKING_CLUB_HOSTS.map((host: Host, index: number) => {
      return <div className="mb-10 grid grid-cols-1 items-center gap-4 md:mb-20 md:grid-cols-[minmax(320px,400px),1fr] md:gap-10" key={index}>
            <div className="mx-auto max-w-xs">
              <TeacherCard {...host} />
            </div>

            <div className="mx-auto w-full md:max-w-[400px] lg:max-w-[600px] xl:max-w-[800px]">
              <Carousel opts={{
            align: 'center',
            loop: true
          }}>
                <CarouselContent className="min-h-[400px]">
                  {host.reviews.map((review, index) => {
                return <CarouselItem key={index} className="flex items-center justify-center sm:basis-1/2 md:basis-full xl:basis-1/2">
                        <ReviewCard text={review.text} author={review.author} textClass="line-clamp-12" openFullReview={onOpenFullReviewClick} className="w-full sm:w-72" />
                      </CarouselItem>;
              })}
                </CarouselContent>

                <CarouselPrevious className="-bottom-10 left-4 top-[unset] z-10 hidden bg-background focus:bg-brand-accent-normal xss:left-24 sm:left-0 sm:top-1/2 sm:flex" />
                <CarouselNext className="-bottom-10 right-4 top-[unset] z-10 hidden bg-background focus:bg-brand-accent-normal xss:right-24 sm:right-0 sm:top-1/2 sm:flex" />

                <div className="pointer-events-none absolute inset-y-0 left-0 hidden h-full w-1/4 bg-gradient-to-r from-background xss:block"></div>
                <div className="pointer-events-none absolute inset-y-0 -right-1 hidden h-full w-1/4 bg-gradient-to-l from-background xss:block"></div>
              </Carousel>
            </div>
          </div>;
    })}

      <Dialog open={open} modal onOpenChange={setOpen}>
        <DialogContent className="max-h-[70%] max-w-[90%] overflow-y-auto rounded-md sm:max-w-[425px]">
          <p>{reviewText}</p>
        </DialogContent>
      </Dialog>
    </Article>;
};